var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00838C",
    fillRule: "evenodd",
    d: "M0 5.705v5.847c0 .708.582 1.283 1.3 1.283h11.4c.718 0 1.3-.575 1.3-1.283V5.705c0-.403-.193-.782-.519-1.024L7.78.46C7.318.12 6.684.12 6.222.46L.519 4.68C.193 4.923 0 5.302 0 5.705zm7 2.382L2.917 5.065 6.222 2.62c.462-.341 1.096-.341 1.558 0l3.3 2.445L7 8.087z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpHeader);
export default __webpack_public_path__ + "static/media/HelpHeader.abf0840b271d73cafaa7a7c8e7a4b443.svg";
export { ForwardRef as ReactComponent };